var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '@environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { SidebarService } from '@ibe/services/ui';
import * as BookedTripActions from '@ibe/store/actions/booked-trip.actions';
import { Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '../../../../store';
import { INDRAAncillariesService } from '@ibe.services/ancillaries.indra.service';
import { EXTRAS_ANCILLARY_STOPOVER_SIGHTSEEING_TOURS, SESSION_VAR_KEY_CURRENCY } from '@ibe.config';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRAGoogleAnalyticsService, EVENT_ACTION_ADD_CART, EVENT_ACTION_REM_CART } from '@ibe.services/google.analytics.indra.service';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
var INDRASightseeingToursComponent = /** @class */ (function () {
    function INDRASightseeingToursComponent(route, router, sanitizer, store, sidebarService, ancillaryService, currencyService, googleAnalytics, bfmStorage, ibeAdminConfigService) {
        var _this = this;
        this.route = route;
        this.router = router;
        this.sanitizer = sanitizer;
        this.store = store;
        this.sidebarService = sidebarService;
        this.ancillaryService = ancillaryService;
        this.currencyService = currencyService;
        this.googleAnalytics = googleAnalytics;
        this.bfmStorage = bfmStorage;
        this.ibeAdminConfigService = ibeAdminConfigService;
        this.city = 'Lisbon';
        this.environment = environment;
        this.isAlive = true;
        this.ancillaries = [{
                'id': 'hop-on-hop-off',
                'label': 'Hop-on Hop-off',
                'title': 'extrasSidebar.sightseeingTours.aria.hopOnHopOffTitle',
                'description': 'extrasSidebar.sightseeingTours.aria.hopOnHopOffDescription',
                'image': './assets/images/ancillaries/activity/hopon.jpg',
                'provider': {
                    'name': 'Gray Line'
                },
                'cash': {
                    'label_prefix': 'bookingDetails.label.ancillaryDiscountPrefix',
                    'label_sufix': ' per day',
                    'amount': 0
                },
                'discount': 'bookingDetails.label.hopOnHopOffDiscount',
                'active': false
            }, {
                'id': 'sightseeing-tours',
                'label': 'Sightseeing tours',
                'title': 'extrasSidebar.sightseeingTours.aria.toursInLisbonTitle',
                'description': 'extrasSidebar.sightseeingTours.aria.sightseeingToursDescription',
                'image': './assets/images/ancillaries/activity/sight.jpg',
                'cash': {
                    'label_prefix': 'bookingDetails.label.ancillaryDiscountPrefix',
                    'label_sufix': ' per day',
                    'amount': 0
                },
                'discount': 'bookingDetails.label.sightseeingToursDiscount',
                'provider': {
                    'name': 'Gray Line'
                },
                'active': false
            },
        ];
        this.addedAncillaries = [];
        this.removedAncillaries = [];
        this.bookedTripStopover$ = this.store.select(fromStore.getSelectedBookedTripStopover);
        this.bookedTripExtras$ = this.store.select(fromStore.getSelectedBookedTripExtras);
        this.bookedTripExtras = [];
        this.formChange = false;
        this.typeExtra = 'sightseeing-tours';
        this.SO_SIGHTSEEING_TOUR_OPTION_1 = 'SO_SIGHTSEEING_TOUR_OPTION_1';
        this.SO_SIGHTSEEING_TOUR_OPTION_2 = 'SO_SIGHTSEEING_TOUR_OPTION_2';
        this.removeAncillary = false;
        this.isModificationDisallowed = false;
        this.sightSeeingIbeadminKey = 'externalURLs.touristVisitors';
        this.currencyCode = this.currencyService.INDRA_getCurrencySymbol().name;
        // this.bookedTripStopover$
        // .pipe(takeWhile(() => this.isAlive))
        // .subscribe(value => {
        // 	if (value) this.city = value.location.city;
        // });
        this.bookedTripExtras$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                var findExtra = value.find(function (cur) { return cur.type == _this.typeExtra; });
                if (findExtra) {
                    _this.bookedTripExtras = findExtra.data;
                    _this.sighseeingToursExtra = [{
                            type: _this.typeExtra,
                            value: findExtra.value,
                            data: _this.bookedTripExtras
                        }];
                    var idsIncludedExtras_1 = _this.bookedTripExtras.map(function (cur) { return cur.id; });
                    _this.ancillaries = _this.ancillaries.map(function (cur) {
                        if (idsIncludedExtras_1.includes(cur.id)) {
                            return Object.assign({}, cur, { active: true });
                        }
                        else {
                            return cur;
                        }
                    });
                    _this.addedAncillaries = _this.ancillaries;
                    _this.formChange = false;
                }
            }
        });
        // get 'isBookingCreated' if existing in URL query params (if true, modification in the sidebar is not allowed)
        var isBookingCreatedParam = this.route.snapshot.paramMap.get('isBookingCreated');
        if (isBookingCreatedParam === 'true') {
            this.isModificationDisallowed = true;
        }
    }
    INDRASightseeingToursComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.extra = this.sidebarService.getSidebarParameters();
        if (this.extra && this.extra[0]['externalReservation']) {
            Object.keys(this.extra[0].externalReservation.stopOverInfo).forEach(function (key) {
                if (key.includes('OPTION_1')) {
                    _this.ancillaries.forEach(function (anc, index) {
                        if (index == 0) {
                            anc.active = true;
                        }
                    });
                }
                else if (key.includes('OPTION_2')) {
                    _this.ancillaries.forEach(function (anc, index) {
                        if (index == 1) {
                            anc.active = true;
                        }
                    });
                }
            });
        }
    };
    INDRASightseeingToursComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
    };
    INDRASightseeingToursComponent.prototype.INDRA_handleDone = function () {
        var _this = this;
        if (this.addedAncillaries.length !== 0 && !this.removeAncillary) {
            var option1 = this.addedAncillaries.findIndex(function (opt) { return opt.id === 'hop-on-hop-off'; });
            var option2 = this.addedAncillaries.findIndex(function (opt) { return opt.id === 'sightseeing-tours'; });
            var stopoverProvider = this.extra[0].selectedExtra[0].ancillaryList[0].type;
            var stopoverInfo = {
                currency: this.currencyService.INDRA_getCurrencySymbol().name,
                amount: this.extra[0].selectedExtra[0].amount,
                status: 'OK'
            };
            this.params = {
                provider: stopoverProvider,
                idReservation: this.extra[0].stopoverCode,
                stopOverInfo: {}
            };
            if (option1 !== -1 && option2 !== -1) {
                this.params.stopOverInfo = {
                    SO_SIGHTSEEING_TOUR_OPTION_1: __assign({}, stopoverInfo),
                    SO_SIGHTSEEING_TOUR_OPTION_2: __assign({}, stopoverInfo),
                };
            }
            else if (option1 !== -1 && option2 === -1) {
                this.params.stopOverInfo = {
                    SO_SIGHTSEEING_TOUR_OPTION_1: __assign({}, stopoverInfo),
                };
            }
            else if (option1 === -1 && option2 !== -1) {
                this.params.stopOverInfo = {
                    SO_SIGHTSEEING_TOUR_OPTION_2: __assign({}, stopoverInfo),
                };
            }
            this.ancillaryService.INDRA_addExternalReservation(this.params, EXTRAS_ANCILLARY_STOPOVER_SIGHTSEEING_TOURS).subscribe(function (res) {
                if (res && res.status === '200' && res.reservations) {
                    _this.INDRA_registerGA_sightseeingTours(res.reservations);
                    _this.store.dispatch(new BookedTripActions.PutBookedTripExtrasAction({
                        stopoverCity: _this.extra[0].stopoverCode,
                        type: _this.typeExtra,
                        value: _this.INDRA_sumAncillary(),
                        data: _this.addedAncillaries,
                        selectedExtra: _this.extra
                    }));
                    _this.sidebarService.closeSidebar();
                }
            }, function (err) {
                if (err) {
                    _this.hasError = true;
                }
            });
        }
        if (this.removedAncillaries.length !== 0 && this.removeAncillary) {
            var option1 = this.removedAncillaries.findIndex(function (opt) { return opt.id === 'hop-on-hop-off'; });
            var option2 = this.removedAncillaries.findIndex(function (opt) { return opt.id === 'sightseeing-tours'; });
            if (option1 !== -1 && option2 !== -1 || this.sighseeingToursExtra[0].data.length === 0) {
                this.ancillaryService.INDRA_removeStopoverExtra(EXTRAS_ANCILLARY_STOPOVER_SIGHTSEEING_TOURS, this.extra[0].stopoverCode, this.extra[0].selectedExtra[0].ancillaryList[0].type).subscribe(function (res) {
                    if (res && res.status === '200') {
                        _this.store.dispatch(new BookedTripActions.RemoveBookedTripExtraByCityAndTypeAction({ stopoverCity: _this.extra[0].stopoverCode, type: _this.typeExtra }));
                        _this.INDRA_removeGA_Extra(_this.typeExtra, _this.extra[0].stopoverCode);
                        _this.sidebarService.closeSidebar();
                    }
                }, function (err) {
                    if (err) {
                        _this.hasError = true;
                    }
                });
            }
            else {
                if (option1 !== -1) {
                    this.ancillaryService.INDRA_removeStopoverExtra(EXTRAS_ANCILLARY_STOPOVER_SIGHTSEEING_TOURS, this.extra[0].stopoverCode, this.SO_SIGHTSEEING_TOUR_OPTION_1).subscribe(function (res) {
                        if (res && res.status === '200') {
                            _this.store.dispatch(new BookedTripActions.RemoveBookedTripExtraActionWithOptions({ type: _this.typeExtra, stopoverCity: _this.extra[0].stopoverCode, ancillary: _this.sighseeingToursExtra[0] }));
                            _this.INDRA_removeGA_Extra(_this.typeExtra, _this.extra[0].stopoverCode);
                            _this.sidebarService.closeSidebar();
                        }
                    }, function (err) {
                        if (err) {
                            _this.hasError = true;
                        }
                    });
                }
                else if (option2 !== -1) {
                    this.ancillaryService.INDRA_removeStopoverExtra(EXTRAS_ANCILLARY_STOPOVER_SIGHTSEEING_TOURS, this.extra[0].stopoverCode, this.SO_SIGHTSEEING_TOUR_OPTION_2).subscribe(function (res) {
                        if (res && res.status === '200') {
                            _this.store.dispatch(new BookedTripActions.RemoveBookedTripExtraActionWithOptions({ type: _this.typeExtra, stopoverCity: _this.extra[0].stopoverCode, ancillary: _this.sighseeingToursExtra[0] }));
                            _this.INDRA_removeGA_Extra(_this.typeExtra, _this.extra[0].stopoverCode);
                            _this.sidebarService.closeSidebar();
                        }
                    }, function (err) {
                        if (err) {
                            _this.hasError = true;
                        }
                    });
                }
            }
        }
        this.params = null;
        this.sidebarService.previousSidebar();
    };
    INDRASightseeingToursComponent.prototype.INDRA_removeGA_Extra = function (type, extra) {
        var eventDataLayerObject = this.googleAnalytics.INDRA_createGA_ExternalAncillarySingleProduct(type, extra);
        eventDataLayerObject.actionField = this.googleAnalytics.INDRA_createGA_ActionField(EVENT_ACTION_REM_CART);
        this.googleAnalytics.INDRA_GA_removeFromCart(sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY), eventDataLayerObject);
    };
    INDRASightseeingToursComponent.prototype.INDRA_registerGA_sightseeingTours = function (extra) {
        var activeBooking = this.bfmStorage.INDRA_getActiveBookedTrip();
        activeBooking.sightseeing_tour = extra.SO_SIGHTSEEING_TOUR[0];
        var eventDataLayerObject = this.googleAnalytics.IBE_createGA_ExtrasProducts(activeBooking);
        eventDataLayerObject.actionField = this.googleAnalytics.INDRA_createGA_ActionField(EVENT_ACTION_ADD_CART);
        this.googleAnalytics.INDRA_GA_addToCart(sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY), eventDataLayerObject);
    };
    INDRASightseeingToursComponent.prototype.INDRA_printTitle = function (ancillary) {
        return ancillary.title;
    };
    INDRASightseeingToursComponent.prototype.INDRA_printType = function (ancillary) {
        return ancillary.type;
    };
    INDRASightseeingToursComponent.prototype.INDRA_printImage = function (ancillary) {
        var url = 'url(' + ancillary.image + ')';
        var backgroundImageUrl = this.sanitizer.bypassSecurityTrustStyle(url);
        return backgroundImageUrl;
    };
    INDRASightseeingToursComponent.prototype.INDRA_ariaLabel = function (ancillary) {
        var label = '';
        label += 'Add a ' + this.INDRA_printType(ancillary) + ': ';
        label += this.INDRA_printTitle(ancillary) + ', ';
        label += 'in partnership with ' + ancillary.provider.name + '.';
        return label;
    };
    INDRASightseeingToursComponent.prototype.INDRA_removeAncillary = function (ancillary) {
        this.formChange = true;
        var ancillaryIdx = this.addedAncillaries.findIndex(function (anc) { return anc.id === ancillary.id; });
        if (ancillaryIdx !== -1) {
            ancillary.active = false;
            this.removedAncillaries.push(ancillary);
            this.removeAncillary = true;
            if (this.sighseeingToursExtra && this.sighseeingToursExtra[0]) {
                this.sighseeingToursExtra[0].data = ancillary;
            }
        }
    };
    INDRASightseeingToursComponent.prototype.INDRA_addAncillary = function (ancillary) {
        this.formChange = true;
        ancillary.active = true;
        this.removeAncillary = false;
        var ancillaryIdx = this.addedAncillaries.findIndex(function (anc) { return anc.id === ancillary.id; });
        if (ancillaryIdx === -1) {
            this.addedAncillaries.push(ancillary);
        }
    };
    INDRASightseeingToursComponent.prototype.INDRA_isActive = function (ancillary) {
        return ancillary.active;
    };
    INDRASightseeingToursComponent.prototype.INDRA_showDone = function () {
        var idsIncludedExtras = this.bookedTripExtras ? this.bookedTripExtras.map(function (cur) { return cur.id; }) : null;
        var idsAncillariesExtras = this.ancillaries.filter(function (cur) { return cur.active; }).map(function (cur) { return cur.id; });
        var countAncillaries = idsAncillariesExtras.filter(function (cur) { return idsIncludedExtras.includes(cur); }).length;
        if (this.extra && this.extra.some(function (el) { return el['readOnly']; })) {
            return false;
        }
        else {
            return this.formChange && (idsIncludedExtras.length || idsAncillariesExtras.length && idsAncillariesExtras.length != countAncillaries);
        }
    };
    INDRASightseeingToursComponent.prototype.INDRA_countActive = function () {
        return this.ancillaries.filter(function (cur) { return cur.active; }).length;
    };
    INDRASightseeingToursComponent.prototype.INDRA_sumAncillary = function () {
        return this.ancillaries.filter(function (cur) { return cur.active; }).reduce(function (acc, cur) { return acc += cur.cash.amount; }, 0);
    };
    INDRASightseeingToursComponent.prototype.INDRA_closeSidebar = function () {
        this.sidebarService.closeSidebar();
    };
    INDRASightseeingToursComponent.prototype.INDRA_gotoURL = function () {
        var urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(this.sightSeeingIbeadminKey);
        return window.open(urlIbeAdmin);
    };
    INDRASightseeingToursComponent.prototype.INDRA_openUrl = function (key) {
        return window.open(this.ibeAdminConfigService.getConfigurationValue(key));
    };
    return INDRASightseeingToursComponent;
}());
export { INDRASightseeingToursComponent };
